import React from 'react';
import './ContactSalesModal.scss';

const ContactSalesModal = ({ cancelModal }) => {
  return (
    <div className="contact-sales-modal">
      <div className="title-row">
        <label className="title">Schedule Publishing</label>
        <button className="close-button" onClick={cancelModal}>
          <img src="icons/close-simple.svg" alt="close" />
        </button>
      </div>

      <p className="body-text">
        Publishing is managed through your enterprise integration.
        To enable schedule publishing, please contact your account
        representative or reach out to our sales team.
      </p>

      <p className="contact-text">
        <a href="mailto:sales@myshyft.com" className="contact-link">
          sales@myshyft.com
        </a>
      </p>

      <div className="confirm-button-wrap">
        <button className="got-it-button" onClick={cancelModal}>
          Got it
        </button>
      </div>
    </div>
  );
};

export default ContactSalesModal;
